import TimelapseContainer from "./TimelapseContainer";

export default TimelapseContainer;
